// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_nd-0";